import classNames from 'classnames';
import { indents } from '../BrowseTree';

const FolderTreeSkeletonRow = ({ indent = 0 }: { indent?: number }) => (
  <div
    className={classNames(
      'flex h-6 justify-between gap-3 animate-pulse',
      indents[indent]
    )}
  >
    <div className="bg-ds-natural-50 w-6 rounded-md" />
    <div className="bg-ds-natural-50 grow rounded-md" />
  </div>
);

const SingleFolderTreeSkeleton = () => (
  <div className="flex flex-col gap-2">
    <FolderTreeSkeletonRow />
    <FolderTreeSkeletonRow indent={1} />
    <FolderTreeSkeletonRow indent={1} />
  </div>
);

export interface FolderTreeSkeletonProps {
  count?: number;
}

export const FolderTreeSkeleton = ({ count = 4 }: FolderTreeSkeletonProps) => {
  return (
    <div className="flex flex-col gap-5 p-2">
      {Array.from(Array(count)).map((_, index) => (
        <SingleFolderTreeSkeleton key={index} />
      ))}
    </div>
  );
};
